import { render } from "./SurfView.vue?vue&type=template&id=236a04a2&scoped=true"
import script from "./SurfView.vue?vue&type=script&lang=js"
export * from "./SurfView.vue?vue&type=script&lang=js"

import "./SurfView.vue?vue&type=style&index=0&id=236a04a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236a04a2"]])

export default __exports__